import { Link as RouterLink } from 'react-router-dom';

import LockOutlined from '@mui/icons-material/LockOutlined';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { Theme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';

const AccessDenied = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        maxWidth: '550px',
        marginLeft: 'auto',
        marginRight: 'auto',
      }}
    >
      <Box sx={{ mb: 3, textAlign: 'center' }}>
        <LockOutlined sx={{ fontSize: 72 }} />
      </Box>
      <Typography variant="h3" component="h1" gutterBottom>
        Page Access Forbidden
      </Typography>
      <Typography 
        variant="h5" 
        component="div" 
        align="center" 
        sx={(theme: Theme) => ({ color: theme.palette.text.primary })}
      >
        It looks like you don&#39;t have the correct permissions to access this page. If this seems
        like an error, Please contact your administrator.
      </Typography>
      <Box sx={{ mt: 4 }}>
        <Button variant="contained" color="secondary" component={RouterLink} to="/">
          Back to Application
        </Button>
      </Box>
    </Box>
  );
};

export default AccessDenied;
